<template lang="pug">
  section.scene-play
    transition( name="headline" )
      headline(
        v-if="displayStatus==='headline'",
        :en="headline.en",
        :jp="headline.jp"
      )

    transition( name="fade" )
      .contents( v-if="displayStatus==='contents'" )
        step-charge(
          v-if="step==='charge'",
          :date="date",
          :member="member",
          :distance="distance",
          @onCharge="onCharge",
          @onChargeDateUpdate="onChargeDateUpdate",
          @onChargeFix="onChargeFix"
        )
        step-result(
          v-if="step==='result'",
          :screenshotImg="screenshotImg",
          :result="result",
          @onRetryClick="onRetryClick",
          @onPlayAgainClick="onPlayAgainClick",
          @onTwitterClick="onTwitterClick",
          @onFacebookClick="onFacebookClick"
        )
    .fade( :class="{ in:fadeStatus }" )
</template>

<script>
import GameMain from "../game/GameMain";
import Common from "./mixins/Common";

import Headline from "./Headline";
import StepCharge from "./scene_play/StepCharge";
import StepResult from "./scene_play/StepResult";

export default {
  mixins: [Common],

  components: {
    Headline,
    StepCharge,
    StepResult
  },

  data() {
    return {
      fadeStatus: false,
      purpose: "",
      member: 0,
      date: null,
      distance: 0,
      result: true,
      power: 0,
      screenshotImg: null
    };
  },

  watch: {
    step: function(val) {
      //send GA Events
      this.$ga.page("/scene_play/" + val);

      switch (val) {
        case "charge":
          this.headline.en = "Challenge!!";
          this.headline.jp = "挑戦しよう！";

          this.showHeadline();
          GameMain.scenePlay_changeStep(this.step);
          break;
        case "go":
          this.headline.en = "My Goal for this year is";
          this.headline.jp = "'" + this.purpose + "'";

          this.showHeadline();
          GameMain.scenePlay_changeStep(this.step);

          setTimeout(() => {
            this.onGo();
          }, 5000);
          break;
        case "jump":
          GameMain.scenePlay_changeStep(this.step);
          break;
        case "result":
          if (this.result) {
            this.headline.en = "Success!";
            this.headline.jp = "成功";
          } else {
            this.headline.en = "Oops";
            this.headline.jp = "残念！";
          }

          this.showHeadline();
          GameMain.scenePlay_screenshot(this.screenshotComplete);

          this.fadeStatus = true;

          setTimeout(() => {
            this.fadeStatus = false;
            this.onResult();
          }, 5000);
          break;
      }
    }
  },

  mounted() {
    this.step = "charge";
    this.purpose = GameMain.getPurpose();
    this.member = GameMain.getMember();
    this.date = GameMain.getDate();
    this.distance = GameMain.getDistance();
  },

  methods: {
    //------------------------------------
    // Step1：Charge
    //------------------------------------
    onCharge(per) {
      GameMain.scenePlay_charge(per);
    },

    onChargeDateUpdate(date) {
      GameMain.scenePlay_dateUpdate(date);
    },

    onChargeFix(param) {
      this.step = "go";
      this.result = param.result;
      this.power = param.power;

      //send GA Events
      this.$ga.event("scene_play", "charge", "distance", this.distance);
      this.$ga.event("scene_play", "charge", "result", this.result);
      this.$ga.event("scene_play", "charge", "power", this.power);
    },

    //------------------------------------
    // Step2：Go
    //------------------------------------
    onGo() {
      this.step = "jump";
      GameMain.scenePlay_boost(this.result, this.power);

      let flyTime = 0;

      switch (this.distance) {
        case 0:
          flyTime = 1500;
          break;
        case 1:
          flyTime = 2500;
          break;
        case 2:
          flyTime = 3000;
          break;
        case 3:
          flyTime = 3500;
          break;
        case 4:
          flyTime = 5000;
          break;
      }

      setTimeout(() => {
        this.step = "result";
      }, flyTime);
    },

    //------------------------------------
    // Step4：Result
    //------------------------------------
    onResult() {
      GameMain.sceneStop();
    },

    screenshotComplete(data) {
      this.screenshotImg = data;
    },

    onRetryClick() {
      this.step = "charge";
      GameMain.sceneChange("play");

      //send GA Events
      this.$ga.event("scene_play", "result", "retry", 1);
    },

    onPlayAgainClick() {
      //send GA Events
      this.$ga.event("scene_play", "result", "play again", 1);

      location.href = "https://happy2019.sretks.com";
    },

    onTwitterClick() {
      let urlBase = "https://twitter.com/share";
      let url = "?url=https://happy2019.sretks.com";
      let text = "&text=My Goal for this year is '" + this.purpose + "'";
      let via = "&via=sretks";

      window.open(encodeURI(urlBase + url + text + via));
    },

    onFacebookClick() {
      let urlBase = "https://www.facebook.com/sharer/sharer.php";
      let url = "?u=https://happy2019.sretks.com";

      window.open(urlBase + url);
    }
  }
};
</script>

<style scoped lang="scss">
.fade {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(1, 1, 1, 1);
  transition: all 500ms ease;
  opacity: 0;
  pointer-events: none;
  z-index: 9999;

  &.in {
    opacity: 1;
  }
}
</style>
